


export const layouts = {
'404': () => import('/app/src/layouts/404.vue'),
'blank': () => import('/app/src/layouts/blank.vue'),
'landing': () => import('/app/src/layouts/landing.vue'),
'tw': () => import('/app/src/layouts/tw.vue'),
'workspace': () => import('/app/src/layouts/workspace.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
